<script setup>
import { useImage } from '@vueuse/core';

const props = defineProps({
  code: {
    type: String,
    required: true,
  },
  withBorder: {
    type: Boolean,
    default: true,
  },
  isRounded: {
    type: Boolean,
    default: false,
  },
});

const FLAG_CDN_URL = 'https://flagcdn.com/w80/';
const FORMAT = '.png';

const url = computed(
  () => FLAG_CDN_URL + props.code.toLocaleLowerCase() + FORMAT,
);

// detect loading error
const imageOptions = computed(() => ({ src: url.value }));
const { error } = useImage(imageOptions);
</script>

<template>
  <span v-if="error" class="c-country-flag" />
  <CImage
    v-else
    class="c-country-flag"
    :class="{
      'c-country-flag--border': withBorder,
      'c-country-flag--round': isRounded,
    }"
    :src="url"
    :alt="code"
    loading="lazy"
  />
</template>

<style scoped lang="scss">
.c-country-flag {
  aspect-ratio: 1.6;
  object-fit: cover;
  object-position: center;
  background-color: $color-gray-3;

  &--border {
    border: 1px solid $color-gray-3;
  }

  &--round {
    border-radius: 50%;
  }
}
</style>
